// TODO: checkboxをこのコンポーネントに寄せていきたい
import PropTypes from 'prop-types'
import React from 'react'
import 'styles/components/checkbox.scss'

const Checkbox = ({ checkboxName, checkboxId, defaultValue, isChecked, isDisabled, size, onChange }) => {
  const sizeStyle = {
    height: `${size}px`,
    width: `${size}px`
  }

  const checkedStyle = {
    fontSize: `${size - 4}px`,
    lineHeight: `${size}px`
  }

  return (
    <div className="checkbox" style={sizeStyle}>
      <input
        className="checkbox-control"
        checked={isChecked}
        defaultValue={defaultValue}
        disabled={isDisabled}
        name={checkboxName}
        id={checkboxId}
        type="checkbox"
        onChange={onChange}
      />
      <label className="checkbox-outline" htmlFor={checkboxId} style={sizeStyle}>
        {isDisabled ? null : <i className="ic-check" style={checkedStyle} />}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  checkboxName: PropTypes.string.isRequired,
  checkboxId: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  size: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

Checkbox.defaultProps = {
  isDisabled: false,
  size: 20
}

export default Checkbox
